import React from 'react'
import { Link, GET_ONE } from 'react-admin'
import moment from 'moment'
import styled from 'styled-components'
import { values, prop, map, trim, isNil, is } from 'ramda'
import { connect } from 'react-redux';
import FolderShared from "@material-ui/icons/FolderShared";
import GenericWhiteboard from './genericWhiteboard'
import dataProviderFactory from "../dataProvider";
import ProfileCompleteMark from "./profileCompleteMark";
import ClientDocumentsModal from "./ClientDocumentsModal";
import { documentTarget } from "../utils/agencyRiderDocuments";

const Card = styled.div(props => ({
    padding: '1em',
    backgroundColor: props.color,
    boxShadow: 'rgb(245,157,29) 0px 1px 3px, rgb(250,228,195)  0px 1px 2px',
    marginTop: '0.5em',
}))

const Header = styled.div({
    display: 'flex',
    alignItems: 'center',

    flexDirection: 'column',
})

// const HeaderDays = styled.div({
//     justifyContent: 'space-between',
//     flexDirection: 'row',
//     display: 'flex',
// })

// const HeaderDay = styled.div(props => ({
//     textAlign: 'center',
//     backgroundColor: props.color
// }))

// const HeaderName = styled.div({
//     textAlign: 'center',
//     fontWeight: 'bold',
// })
// const HeaderDate = styled.div({
//     textAlign: 'center',
// })

// const Name = styled.span({
// })

// const RoomDetail = styled.span({
//     fontStyle: 'italic',
//     display: 'flex',
//     flexDirection: 'column',
// })

// const VipDetail = styled.span({
//     fontStyle: 'italic',
//     fontWeight: 'bold',
//     display: 'flex',
//     flexDirection: 'column',
// })

// const DeviceDetail = styled.span({
//     fontStyle: 'italic',
//     fontWeight: 'bold',
//     display: 'flex',
//     flexDirection: 'column',
// })

// const InsuranceDetail = styled.span({
//     fontStyle: 'italic',
//     fontWeight: 'bold',
//     display: 'flex',
//     flexDirection: 'column',
// })

// const BirthdayIcon = styled.span({
//     fontStyle: 'italic',
//     fontWeight: 'bold',
//     textAlign: 'center',
//     width: '2rem',
//     display: 'inline-block',
// })

// const Column = styled.div(props => ({
//     fontSize: '14px',
//     marginBottom: '0.5rem',
//     marginTop: '0.5rem',
//     display: 'flex',
//     flexDirection: 'column',
//     width: '150px',
// }))

// const ColumnSummary = styled.div(props => ({
//     fontSize: '14px',
//     marginBottom: '0.5rem',
//     marginTop: '0.5rem',
//     display: 'flex',
//     flexDirection: 'column',
// }))

const HeaderRow = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    flexGrow: '1',
    flexDirection: 'row',
    fontSize: '14px',
    textAlign: 'center',
    width: '100%',
})

const Row = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    flexGrow: '1',
    flexDirection: 'row',
    fontSize: '14px',
    textAlign: 'center',
    marginTop: '1rem',
})

const BoldHeaderRow = styled(HeaderRow)({
    fontWeight: 'bold'
})

const DivColumn = styled.div({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
})

const NameWithIcon = styled.div({
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
})
const SpanNationality = styled.span({
    fontWeight: '400',
    textTransform: 'capitalize',
})

// const RowDriverPassengerBike = styled.div({
//     flexGrow: '1',
//     fontSize: '14px',
//     marginBottom: '0.5rem',
//     marginTop: '0.5rem',
//     display: 'flex',
//     alignItems: 'baseline',
//     justifyContent: 'space-between'
// })

// const RowDetails = styled.div({
//     display: 'flex'
// })

const duration = (date1, time1, date2, time2) => {
    const days = moment(date2).diff(date1, 'days')
    if (time1 === '10:00:00' && time2 === '18:00:00') {
        return days + 1
    } else if (time1 === '18:00:00' && time2 === '10:00:00') {
        return days - 1
    }
    return days
}

async function getCountry(id) {
    const dataProvider = await dataProviderFactory("rest");
    const models = await dataProvider(GET_ONE, "countries", { id })
    return models.data.country;
}

class RentalCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          country: '',
          clientDocumentsModalOpen: false,
          documentsClientId: null,
          documentsRentalId: null,
        };
      }

    openClientDocuments = (rental, e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const target = documentTarget(rental);
        if (!target.clientId && !target.rentalId) return;
        this.setState({
            clientDocumentsModalOpen: true,
            documentsClientId: target.clientId,
            documentsRentalId: target.rentalId,
        });
    }

    closeClientDocuments = () => {
        this.setState({
            clientDocumentsModalOpen: false,
            documentsClientId: null,
            documentsRentalId: null,
        });
    }
    
      componentDidMount() {
        this.fetchCountry();
      }

    fetchCountry = async () => {
        const { driver } = this.props;
        let nationality = '';

        if (!isNil(driver.country)) {
            nationality = await getCountry(driver.country.id);
        }
        this.setState({ country: nationality });
    };


    getTimeOfDay = (time) => {
        if (time === '10:00:00') {
            return "AM"
        } else {
            return "PM"
        }
    }

    daysWithLink = (date_1, time_1, date_2, time_2) => {
        return (
            <Row>
                <Link to={{ pathname: `/rental_clients/${this.props.id}/show`, search: `?from=whiteboard`, }} /*target="_blank"*/>
                    {duration(date_1, time_1, date_2, time_2)} days
                </Link>
            </Row>
        )
    }

    nameWithLink = () => {
        const { driver, date_1, date_2, booking, client_id } = this.props;
        const target = documentTarget(this.props);
        const clientId = target.clientId || (driver && driver.id) || client_id;

        return (
            <BoldHeaderRow>
                <div>{moment(date_1).format('DD')}</div>
                <DivColumn>
                    <NameWithIcon>
                        <Link to={{ pathname: `/clients/${driver.id}`, search: `?from=whiteboard`,}} target="_blank">
                            {`${booking.r_first_name} ${booking.r_last_name}`}
                        </Link>
                        <ProfileCompleteMark record={this.props} size={20} />
                        {(target.rentalId || clientId) ? (
                            <span
                                title="View / upload client documents"
                                alt="View / upload client documents"
                                onClick={e => this.openClientDocuments(this.props, e)}
                                style={{
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    verticalAlign: "middle",
                                    color: "#555",
                                }}
                            >
                                <FolderShared style={{ fontSize: 18 }} />
                            </span>
                        ) : null}
                    </NameWithIcon>
                    <SpanNationality>{this.state.country}</SpanNationality>
                </DivColumn>
                <div>{moment(date_2).format('DD')}</div>
            </BoldHeaderRow>
        )
    }

    vehicleWithLink = () => {
        if (this.props.vehicle.length > 0) {
            return (
                <Row>
                    <Link to={{ pathname: `/history/${this.props.vehicle[0].id}` }} target="_blank">
                        {`${this.props.vehicle[0].licence_plate} ${this.props.vehicle[0].renting ? "®" : ""}/${this.props.vehicle[0].vehicle_color}/${this.props.vehicle[0].vehicle_mileage} km`}
                    </Link>
                </Row>
            )
        }
        return (
            <Row>
                {' No vehicle'}
            </Row>
        )
    }

    renderDeviceIfNeeded = (device) => {
        if (device !== undefined) {
            return (
                <Row>
                    <Link to={{ pathname: `/item_history/gps_devices/${device.id}` }} target="_blank">
                        {prop('model', device)}
                    </Link>
                </Row>
            )
        }
        return null
    }

    renderTankbagIfNeeded = (tankbag) => {
        if (tankbag !== undefined) {
            return (
                <Row>
                    <Link to={{ pathname: `/item_history/tankbags/${tankbag.id}` }} target="_blank">
                        {prop('model', tankbag)}
                    </Link>
                </Row>
            )
        }
        return null
    }

    renderSeatIfNeeded = (seat) => {
        if (seat !== undefined) {
            return (
                <Row>
                    <Link to={{ pathname: `/item_history/seats/${seat.id}` }} target="_blank">
                        {prop('model', seat)}
                    </Link>
                </Row>
            )
        }
        return null
    }

    renderJacketIfNeeded = (jackets) => {
        if (jackets !== undefined) {
            return (
                values(map((jacket) => {
                    return (
                        <Row>
                            <Link to={{ pathname: `/item_history/jackets/${jacket.id}` }} target="_blank">
                                {prop('model', jacket)}
                            </Link>
                        </Row>
                    )
                }, jackets))
            )
        }
        return null
    }

    renderGloveIfNeeded = (gloves) => {
        if (gloves !== undefined) {
            return (
                values(map((glove) => {
                    return (
                        <Row>
                            <Link to={{ pathname: `/item_history/gloves/${glove.id}` }} target="_blank">
                                {prop('model', glove)}
                            </Link>
                        </Row>
                    )
                }, gloves))
            )
        }
        return null
    }

    renderHelmetIfNeeded = (helmets) => {
        if (helmets !== undefined) {
            return (
                values(map((helmet) => {
                    return (
                        <Row>
                            <Link to={{ pathname: `/item_history/helmets/${helmet.id}` }} target="_blank">
                                {prop('model', helmet)}
                            </Link>
                        </Row>
                    )
                }, helmets))
            )
        }
        return null
    }

    render() {

        const { id, date_1, date_2, time_1, time_2, location_1, driver, device, seat, jacket, helmet, tankbag, glove, vehicle } = this.props
        return (
            <Card color={trim(location_1.color)} key={id}>
                <Header>
                    {this.nameWithLink()}
                    <HeaderRow>
                        <div>{this.getTimeOfDay(time_1)}</div>
                        <div>{this.getTimeOfDay(time_2)}</div>
                    </HeaderRow>
                    {this.daysWithLink(date_1, time_1, date_2, time_2)}
                    <Row>
                        {(vehicle.length > 0 && vehicle[0].model) ? vehicle[0].model.model_name : ''}
                    </Row>
                    {this.vehicleWithLink()} <br />
                    {this.renderDeviceIfNeeded(device[0])}
                    {this.renderSeatIfNeeded(seat[0])}
                    {this.renderJacketIfNeeded(jacket)}
                    {this.renderGloveIfNeeded(glove)}
                    {this.renderHelmetIfNeeded(helmet)}
                    {this.renderTankbagIfNeeded(tankbag[0])}
                </Header>
                <ClientDocumentsModal
                    open={this.state.clientDocumentsModalOpen}
                    onClose={this.closeClientDocuments}
                    clientId={this.state.documentsClientId}
                    rentalId={this.state.documentsRentalId}
                />
            </Card>
        )
    }
}




const RentalsWhiteboard = (props) => <GenericWhiteboard title="Rentals Whiteboard" resource="rentals" dateField="date_1" filter={{ type: 2 }} card={RentalCard} createUrl={'#/rentals/create'} />




const mapStateToProps = function (state) {
    return {
        state: state,
    }
}

export default connect(mapStateToProps)(RentalsWhiteboard);



// WEBPACK FOOTER //
// ./src/components/rentalsWhiteboard.js